import React, { memo, useMemo } from 'react';

import { useTranslation } from 'react-i18next';

import './index.scss';
import { ACCOUNT_ORDER_STATUS, DELIVERY_TYPE, ORDER_PROCESS_STEP } from '../../../../utils/enums';

export const StatusDraft = memo(
    ({
        hasCourier,
        extendedStatus,
        status,
        readinessTime,
        isCookingReady,
        hideReadyStatus,
        processStep,
        deliveryType
    }) => {
        const { t } = useTranslation();

        const statusData = useMemo(() => {
            if (
                !!status &&
                [ACCOUNT_ORDER_STATUS.ready, ACCOUNT_ORDER_STATUS.accepted].includes(status) &&
                extendedStatus === 0
            ) {
                return {
                    text: t('draft.pickupInProgress'),
                    color: '#FF8A00'
                };
            }

            if (!hasCourier && status !== ACCOUNT_ORDER_STATUS.canceled && status !== ACCOUNT_ORDER_STATUS.finished) {
                return {
                    text:
                        deliveryType === DELIVERY_TYPE.takeAway
                            ? t('draft.notAssignedTakeAway')
                            : t('draft.notAssigned'),
                    color: '#EC673E',
                    fontWeight: 'bold'
                };
            }

            switch (status) {
                case ACCOUNT_ORDER_STATUS.pending:
                    return {
                        text: t('draft.pending'),
                        color: '#FF8A00'
                    };
                case ACCOUNT_ORDER_STATUS.delivering:
                    return {
                        text: t('draft.delivering'),
                        color: '#417B07'
                    };
                case ACCOUNT_ORDER_STATUS.finished:
                    return {
                        text: t('draft.finished'),
                        color: '#007AFF'
                    };
                case ACCOUNT_ORDER_STATUS.canceled:
                    return {
                        text: t('draft.canceled'),
                        color: '#EC673E'
                    };
                default: {
                    if (processStep !== undefined && processStep < ORDER_PROCESS_STEP.delivering) {
                        return {
                            text: t('draft.notApproved'),
                            color: '#26bedc'
                        };
                    }

                    return {
                        text: t('draft.pendingPickup'),
                        color: '#DF61FF'
                    };
                }

            }

        }, [deliveryType, extendedStatus, hasCourier, processStep, status, t]);

        return (
            <div className={'statusDraft'}>
                {!hideReadyStatus && readinessTime && isCookingReady && (
                    <>
                        <div className={'readyText'}>{t('draft.ready')}</div>
                        <div className={'separator'}>|</div>
                    </>
                )}
                <div
                    className='status'
                    style={{
                        color: statusData?.color, fontWeight: statusData?.fontWeight,
                    }}
                >
                    {statusData?.text}
                </div>
            </div>
        );
    }
);